import Edit from "@mui/icons-material/Edit";
import { Box, IconButton, TableCell, TableRow, Typography } from "@mui/material";
import RoleBadge from "components/shared/RoleBadge";

import RoleTypeChip from "../RoleTypeChip";
import type { Role } from "../types";
import UserCount from "../UserCount";

interface RoleTableRowProps {
    role: Role;
    onEdit: (role: Role) => void;
}

const RoleTableRow = ({ role, onEdit }: RoleTableRowProps) => {
    return (
        <TableRow
            hover
            sx={{
                "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
            }}
        >
            <TableCell>
                <Box>
                    <Typography variant="body2" fontWeight={500} color="text.primary">
                        {role.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
                        {role.description}
                    </Typography>
                </Box>
            </TableCell>
            <TableCell>
                <Box display="flex" flexWrap="wrap" gap={0.5}>
                    {role.brands.map((brand) => (
                        <RoleBadge key={brand} label={brand} variant="filled" />
                    ))}
                </Box>
            </TableCell>
            <TableCell>
                <Box display="flex" flexWrap="wrap" gap={0.5}>
                    {role.contractTypes.map((type) => (
                        <RoleBadge key={type} label={type} variant="outlined" />
                    ))}
                </Box>
            </TableCell>
            <TableCell>
                <UserCount count={role.userCount} />
            </TableCell>
            <TableCell>
                <RoleTypeChip type={role.type} />
            </TableCell>
            <TableCell align="right">
                <Box display="flex" justifyContent="flex-end" gap={1}>
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            onEdit(role);
                        }}
                        sx={{
                            "&:hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.04)",
                            },
                        }}
                    >
                        <Edit fontSize="small" />
                    </IconButton>
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default RoleTableRow;
